"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDefaultNamespacesWithFetchedTranslations = void 0;
/**
 * @deprecated Use only when translations keys from Online are different than default value default value, this function enables to use Online with POEditor translations at same time.
 *
 * Replaces values in the default translations with corresponding values from fetched translations,
 * based on matching keys. Returns a new object with the updated translations.
 * @typeParam T Type of the fetched translations object.
 * @typeParam K Type of the default translations with namespaces object.
 * @param fetchedTranslations The object containing fetched translations.
 * @param defaultTranslationsWithNamespaces The object containing default translations with namespaces.
 * @returns A new object with updated translations based on fetched translations.
 */
const updateDefaultNamespacesWithFetchedTranslations = (fetchedTranslations, defaultTranslationsWithNamespaces) => {
  // Create a deep clone copy of the default translations with namespaces
  const result = JSON.parse(JSON.stringify(defaultTranslationsWithNamespaces));

  // Iterate over each namespace in the result object
  Object.keys(result).forEach(namespace => {
    // Check if the namespace exists in the result object
    if (Object.prototype.hasOwnProperty.call(result, namespace)) {
      // Get the defaultNamespace object
      const currentNamespaceWithTranslations = result[namespace];

      // Check if defaultNamespace is truthy
      if (currentNamespaceWithTranslations && fetchedTranslations) {
        // Iterate over each key-value pair in the defaultNamespace
        Object.entries(currentNamespaceWithTranslations).forEach(([defaultKey, defaultValue]) => {
          // Get the translated value from fetchedTranslations using the defaultValue as key
          const translatedValue = fetchedTranslations[defaultValue];

          // Check if fetchedTranslations has the defaultValue as key and translatedValue is truthy
          if (Object.prototype.hasOwnProperty.call(fetchedTranslations, defaultValue) && translatedValue) {
            // Update the value in the defaultNamespace with the translated value
            currentNamespaceWithTranslations[defaultKey] = translatedValue;
          }
        });
      }
    }
  });

  // Return the object with updated translations
  return result;
};
exports.updateDefaultNamespacesWithFetchedTranslations = updateDefaultNamespacesWithFetchedTranslations;
